import React from "react";

export default function MiniBar(props) {
  return (
    <div style={{ height: 3, background: "#e4d9c8", borderRadius: 100, overflow: "hidden" }}>
      <div style={{ height: "100%", borderRadius: 100, background: props.color, width: props.pct + "%", transition: "width 1.5s cubic-bezier(.4,0,.2,1)" }} />
    </div>
  );
}
